<template>
  <GChart
    :type="type"
    :data="data"
    :options="chartOptions"
    :rootProps="{'data-testid': '9'}"
  />
</template>
<script lang="js">
import { GChart } from 'vue-google-charts'
import VueTypes from 'vue-types'
import { defineComponent } from 'vue'

export const GoogleBasicPieChart = defineComponent({
  name: 'GoogleBasicPieChart',
  components: {
    GChart
  },
  data () {
    return {
      chartOptions: {
        title: this.title,
        width: this.width,
        height: this.height,
        is3D: true,
        chartArea: { width: this.chartArea }
      }
    }
  },
  methods: {},
  props: {
    type: VueTypes.string.def('PieChart'),
    width: VueTypes.string.def('100%'),
    height: VueTypes.number.def(300),
    data: VueTypes.array,
    title: VueTypes.string.def('My Daily Activities'),
    chartArea: VueTypes.string.def('50%')
  }
})

export default GoogleBasicPieChart
</script>
